module.exports = __webpack_public_path__ + "img/BioTrackThc_logo_white.7d76532e.svg";